import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
    Card,
    Divider,
    Box,
  Avatar,
  Chip,
  Stack,
  Paper,
  Container,
  Fade,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import { Loader } from "../../components/CustomLoader";
  import { boostersServices } from "../../services/AllServices";
  import errorHandler from "../../utils/errorHandler";
  import { capitalize } from "../../utils/helpers";
import Iconify from "../../components/iconify";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMore from "@mui/icons-material/ExpandMore";
  
  const ViewBoostersManagement = ({ id, show, onHide }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
  const [expandedPanel, setExpandedPanel] = useState(0); // Default to first game type expanded
  
    const userData = async () => {
      try {
        setLoading(true);
        const response = await boostersServices.getOneBoosters({ id: id });
        setData(response.data.data);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (id) {
        userData();
      }
    }, [id]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : false);
  };

  const CONTEST_TYPE_ICONS = {
    daily: "mdi:calendar-day",
    week: "mdi:calendar-week", 
    monthly: "mdi:calendar-month",
    season: "mdi:calendar"
  };
  
    return (
    <Dialog 
      maxWidth="lg" 
      fullWidth 
      open={show} 
      onClose={onHide}
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: 'linear-gradient(145deg, #1a202c 0%, #2d3748 100%)',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden'
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 3,
          background: 'linear-gradient(135deg, #00a1dd 0%, #42a5f5 100%)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
          }
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              sx={{
                width: 56,
                height: 56,
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(255, 255, 255, 0.3)'
              }}
            >
              <AutoAwesomeIcon sx={{ fontSize: 28, color: 'white' }} />
            </Avatar>
            <Box>
              <Typography variant="h5" sx={{ color: 'white', fontWeight: 700, mb: 0.5 }}>
          Booster Details
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                View booster configuration and settings
              </Typography>
            </Box>
          </Stack>
          <Button
            onClick={onHide}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <CloseIcon />
          </Button>
        </Stack>
      </Box>
  
        {loading ? (
        <Box sx={{ p: 6, textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ color: 'primary.main' }} />
          <Typography sx={{ mt: 3, color: 'text.secondary' }} variant="h6">
            Loading booster details...
          </Typography>
        </Box>
      ) : (
        <Fade in timeout={500}>
          <DialogContent sx={{ p: 0 }}>
            <Container maxWidth="lg" sx={{ py: 4 }}>
              <Stack spacing={4}>
                {/* General Information Section */}
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                    background: 'linear-gradient(145deg, #1a202c 0%, #2d3748 100%)',
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    sx={{
                      p: 3,
                      background: 'linear-gradient(90deg, rgba(0, 161, 221, 0.1) 0%, rgba(66, 165, 245, 0.1) 100%)',
                      borderBottom: '1px solid',
                      borderColor: 'divider'
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Avatar
                        sx={{
                          width: 40,
                          height: 40,
                          background: 'linear-gradient(135deg, #00a1dd 0%, #42a5f5 100%)'
                        }}
                      >
                        <SettingsIcon sx={{ fontSize: 20, color: 'white' }} />
                      </Avatar>
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
              General Information
            </Typography>
                    </Stack>
                  </Box>
                  
                  <Box sx={{ p: 4 }}>
                    <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                        <Box
                          sx={{
                            p: 3,
                            borderRadius: 2,
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1, fontWeight: 600 }}>
                            Booster Name
                </Typography>
                          <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
                  {capitalize(data?.name)}
                </Typography>
                        </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                        <Box
                          sx={{
                            p: 3,
                            borderRadius: 2,
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1, fontWeight: 600 }}>
                            Booster Type
                </Typography>
                          <Chip
                            label={data?.type}
                            sx={{
                              backgroundColor: 'rgba(0, 161, 221, 0.2)',
                              color: 'primary.main',
                              fontWeight: 600,
                              border: '1px solid rgba(0, 161, 221, 0.3)'
                            }}
                          />
                        </Box>
              </Grid>             
              <Grid item xs={12}>
                        <Box
                          sx={{
                            p: 3,
                            borderRadius: 2,
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1, fontWeight: 600 }}>
                  Description
                </Typography>
                          <Typography variant="body1" sx={{ color: 'white', lineHeight: 1.6 }}>
                            {data?.description}
                          </Typography>
                        </Box>
              </Grid>
            </Grid>
                  </Box>
                </Card>

                {/* Game Types Section */}
                  <Card
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                    background: 'linear-gradient(145deg, #1a202c 0%, #2d3748 100%)',
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    sx={{
                      p: 3,
                      background: 'linear-gradient(90deg, rgba(156, 39, 176, 0.1) 0%, rgba(233, 30, 99, 0.1) 100%)',
                      borderBottom: '1px solid',
                      borderColor: 'divider'
                    }}
                  >
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                            background: 'linear-gradient(135deg, #9c27b0 0%, #e91e63 100%)'
                          }}
                        >
                          <SportsEsportsIcon sx={{ fontSize: 20, color: 'white' }} />
                        </Avatar>
                        <Box>
                          <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>
                            Game Types Configuration
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                            Configured contest types for each game type
                          </Typography>
                        </Box>
                      </Stack>
                      <Chip
                        label={`${data?.allowedGameTypes?.length || 0} Game Types`}
                        sx={{
                          backgroundColor: 'rgba(156, 39, 176, 0.2)',
                          color: '#e91e63',
                          fontWeight: 600,
                          border: '1px solid rgba(156, 39, 176, 0.3)'
                        }}
                      />
                    </Stack>
                  </Box>
                  
                  <Box sx={{ p: 4 }}>
                    {data?.allowedGameTypes && data.allowedGameTypes.length > 0 ? (
                      <Stack spacing={3}>
                        {data.allowedGameTypes.map((game, idx) => (
                          <Accordion
                            key={idx}
                            expanded={expandedPanel === idx}
                            onChange={handleAccordionChange(idx)}
                            sx={{
                              borderRadius: 3,
                              background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.05) 100%)',
                              border: '1px solid',
                              borderColor: 'divider',
                              overflow: 'hidden',
                              transition: 'all 0.3s ease',
                              '&:before': { display: 'none' },
                              '&:hover': {
                                borderColor: 'primary.main',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 8px 32px rgba(0, 161, 221, 0.15)',
                              },
                              '&.Mui-expanded': {
                                borderColor: 'primary.main',
                                boxShadow: '0 8px 32px rgba(0, 161, 221, 0.15)',
                              }
                            }}
                          >
                            {/* Game Type Header */}
                            <AccordionSummary
                              expandIcon={<ExpandMore sx={{ color: 'primary.main' }} />}
                              sx={{
                                p: 2.5,
                                background: 'linear-gradient(90deg, rgba(0, 161, 221, 0.1) 0%, rgba(66, 165, 245, 0.1) 100%)',
                                borderBottom: '1px solid',
                                borderColor: 'divider',
                                '& .MuiAccordionSummary-content': {
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  m: 0
                                }
                              }}
                            >
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Avatar
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    background: 'linear-gradient(135deg, #00a1dd 0%, #42a5f5 100%)',
                                    boxShadow: '0 4px 16px rgba(0, 161, 221, 0.3)'
                                  }}
                                >
                                  <Iconify icon="mdi:gamepad-variant" width={20} />
                                </Avatar>
                                <Box>
                                  <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
                      {game.gameType?.toUpperCase()}
                    </Typography>
                                  <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                                    Game Type Configuration
                                  </Typography>
                                </Box>
                              </Stack>
                              <Chip
                                label={`${game.allowedContestTypes?.length || 0} Contest Types`}
                                size="small"
                                sx={{
                                  backgroundColor: 'rgba(0, 161, 221, 0.2)',
                                  color: 'primary.main',
                                  fontWeight: 600,
                                  border: '1px solid rgba(0, 161, 221, 0.3)'
                                }}
                              />
                            </AccordionSummary>

                            {/* Contest Types Configuration */}
                            <AccordionDetails sx={{ p: 2.5 }}>
                              <Typography variant="subtitle2" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
                                Allowed Contest Types for {game.gameType?.toUpperCase()}:
                              </Typography>
                              
                              <Grid container spacing={1.5}>
                                {game.allowedContestTypes.map((contestType, contestIdx) => (
                                  <Grid item xs={12} sm={6} md={3} key={contestIdx}>
                                    <Paper
                                      elevation={0}
                                      sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        border: '2px solid',
                                        borderColor: 'primary.main',
                                        background: 'linear-gradient(135deg, rgba(0, 161, 221, 0.1) 0%, rgba(66, 165, 245, 0.1) 100%)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                          background: 'linear-gradient(135deg, rgba(0, 161, 221, 0.15) 0%, rgba(66, 165, 245, 0.15) 100%)',
                                          transform: 'translateY(-2px)',
                                        }
                                      }}
                                    >
                                      <Stack direction="row" alignItems="center" spacing={1.5}>
                                        <Avatar
                                          sx={{
                                            width: 28,
                                            height: 28,
                                            background: 'linear-gradient(135deg, #00a1dd 0%, #42a5f5 100%)',
                                            transition: 'all 0.3s ease'
                                          }}
                                        >
                                          <Iconify 
                                            icon={CONTEST_TYPE_ICONS[contestType] || "mdi:calendar"} 
                                            width={14} 
                                          />
                                        </Avatar>
                                        <Box sx={{ flex: 1 }}>
                                          <Typography 
                                            variant="body2" 
                                            sx={{ 
                                              color: 'white',
                                              fontWeight: 600,
                                              fontSize: '0.875rem'
                                            }}
                                          >
                                            {capitalize(contestType)}
                    </Typography>
                                          <Typography 
                                            variant="caption" 
                                            sx={{ 
                                              color: 'rgba(255, 255, 255, 0.7)',
                                              fontSize: '0.75rem'
                                            }}
                                          >
                                            Contest Type
                    </Typography>
                                        </Box>
                                      </Stack>
                                    </Paper>
                </Grid>
              ))}
            </Grid>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </Stack>
                    ) : (
                      <Box
                        sx={{
                          p: 6,
                          textAlign: 'center',
                          borderRadius: 3,
                          background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.05) 100%)',
                          border: '2px dashed',
                          borderColor: 'divider'
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 80,
                            height: 80,
                            mx: 'auto',
                            mb: 3,
                            background: 'linear-gradient(135deg, #9c27b0 0%, #e91e63 100%)',
                            boxShadow: '0 8px 32px rgba(156, 39, 176, 0.3)'
                          }}
                        >
                          <Iconify icon="mdi:gamepad-variant" width={40} />
                        </Avatar>
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 2, fontWeight: 600 }}>
                          No Game Types Configured
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          This booster doesn't have any game types configured yet.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Card>
              </Stack>
            </Container>
          </DialogContent>
        </Fade>
      )}

      <DialogActions sx={{ p: 3, background: 'rgba(255, 255, 255, 0.02)' }}>
        <Button
          variant="outlined"
          onClick={onHide}
          startIcon={<CloseIcon />}
          sx={{
            borderRadius: 2,
            borderColor: 'divider',
            color: 'text.secondary',
            '&:hover': {
              borderColor: 'primary.main',
              color: 'primary.main',
            }
          }}
        >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ViewBoostersManagement;